import Vue from 'vue/dist/vue.js';
const axios = require('axios').default;
const _ = require('lodash');
const moment = require('moment');

if (document.getElementById('app-search')) {

new Vue({
    el: '#app-search',
    data: {
        items: null ,
        loading: 0,
        itemsCount: 0,
        scatts: null,
        sidebarMenu: 0,
        search: null,
        term: 0,
        view: 0,
        loading: 0,
        count: 20,
        courseset: 'all',
        notification: null,
        learning_path_id: null,
        terms_reduced: null 
    },
    filters: {
        getHumanDate: function(date) {
            return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
        }
    },
    methods: {
        getCourses: function(params) {
            this.loading = 1;
            axios({
                    method: 'GET',
                    url: params,
                    headers: {
                        'X-WP-Nonce': this.scatts.nonce
                    },
                })
                    .then( response => {
                        this.loading = 0;
                        if (response.status === 200) { 
                            if (response.data.length > 0) {
                                this.items = response.data;
                                this.notification = null;
                            } else {
                                this.items = null;
                                this.notification = 'No results';
                            }
                        } else { 
                            this.items = null;
                            this.notification = 'Not authenticated';
                        } 

                        if (this.items) {
                            this.itemsCount = this.items.length;
                        } else {
                            this.itemsCount = 0;
                        }
                    } 
                )
        },
    },
    mounted () {
        this.scatts = JSON.parse(this.$el.getAttribute('data-scatts'));
        this.term = this.scatts.all_courses_term_id;
        if (location.hash) {
            if (location.hash.substr(1) in this.terms_reduced) {
                this.term = this.terms_reduced[location.hash.substr(1)].term_id;
                this.courseset = 'all';
                this.getCourses(this.scatts.baseurl + 'course_set='+ this.courseset + '&term=' + this.term + '&count=' + this.count)
            }
        }
        if (this.courseset != 'paths') {
            this.getCourses(this.scatts.baseurl + 'course_set='+ this.courseset + '&term=' + this.term + '&count=' + this.count)
        }
    },
    watch: {
        search: _.debounce(function (val, oldVal) {
            this.getCourses(this.scatts.baseurl + 'course_set='+ this.courseset + '&term=' + (this.term) + '&count=' + this.count + "&s=" + (val ? val : ''));
        }, 200),
        count: function(val) { 
            this.getCourses(this.scatts.baseurl + 'course_set='+ this.courseset + '&term=' + (this.term) + '&count=' + this.count + "&s=" + (this.search ? this.search : ''));
        },
        courseset: function(val) { 
            this.search = null;
            if (val == "paths") {
                this.items = null;
                this.notification = null;
            } else {
                this.term = this.scatts.all_courses_term_id;
                this.getCourses(this.scatts.baseurl + 'course_set='+ this.courseset + '&term=' + (this.term) + '&count=' + this.count );
            }
        },
        term: function (val, oldVal) {
            this.items = null;
            this.notification = null;
            this.search = null;
            this.getCourses(this.scatts.baseurl + 'course_set=all&term=' + val + '&count=' + this.count );
        }
    }
});

};
